module.exports = __webpack_public_path__ + "img/Leap Learning Manuals.8ed54d2e.png";